import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SEO = ({ title, description, keywords, canonical }) => {
  const location = useLocation();
  const baseUrl = "https://chirayilgold.com";

  useEffect(() => {
    // Default fallback values
    const defaultTitle = "Chirayil Gold and Diamonds | Luxury Jewelry & Savings Schemes";
    const defaultDesc =
      "Exquisite craftsmanship in fine jewelry. Discover our premium collections of gold, diamonds, and flexible gold savings schemes.";
    const defaultKeywords =
      "gold jewelry, diamonds, gold schemes, precious stones, luxury jewelry, bridal collections, Chirayil Gold";

    const pageTitle = title ? `${title} | Chirayil Gold and Diamonds` : defaultTitle;
    const pageDesc = description || defaultDesc;
    const pageKeywords = keywords || defaultKeywords;
    const pageUrl = canonical ? `${baseUrl}${canonical}` : `${baseUrl}${location.pathname}`;

    // Update document title
    document.title = pageTitle;

    // Helper function to set meta element attribute
    const setMetaAttribute = (selector, attr, value) => {
      let element = document.querySelector(selector);
      if (!element) {
        element = document.createElement("meta");
        const match = selector.match(/\[(name|property)="([^"]+)"\]/);
        if (match) {
          element.setAttribute(match[1], match[2]);
          document.head.appendChild(element);
        }
      }
      element.setAttribute(attr, value);
    };

    // Update meta tags
    setMetaAttribute('meta[name="description"]', "content", pageDesc);
    setMetaAttribute('meta[name="keywords"]', "content", pageKeywords);
    setMetaAttribute('meta[property="og:title"]', "content", pageTitle);
    setMetaAttribute('meta[property="og:description"]', "content", pageDesc);
    setMetaAttribute('meta[property="og:url"]', "content", pageUrl);

    // Update Canonical link tag
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute("href", pageUrl);
  }, [title, description, keywords, canonical, location.pathname]);

  return null;
};

export default SEO;
